import type { FC, SVGProps } from 'react';

const WindIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 8C19.551 8 18.3378 9.02936 18.06 10.3979C17.8403 11.4804 16.7846 12.1798 15.7022 11.96C14.6197 11.7403 13.9203 10.6846 14.14 9.60214C14.7887 6.40616 17.6111 4 21 4C24.866 4 28 7.134 28 11C28 14.866 24.866 18 21 18H10C8.89544 18 8 17.1046 8 16C8 14.8954 8.89544 14 10 14H21C22.6568 14 24 12.6569 24 11C24 9.34314 22.6568 8 21 8ZM37 16C35.551 16 34.3378 17.0294 34.06 18.3979C33.8404 19.4804 32.7846 20.1798 31.7022 19.96C30.6196 19.7403 29.9202 18.6846 30.14 17.6021C30.7888 14.4062 33.6112 12 37 12C40.866 12 44 15.134 44 19C44 22.866 40.866 26 37 26H6C4.89544 26 4 25.1046 4 24C4 22.8954 4.89544 22 6 22H37C38.6568 22 40 20.6568 40 19C40 17.3431 38.6568 16 37 16ZM26.06 37.6022C26.3378 38.9706 27.551 40 29 40C30.6568 40 32 38.6568 32 37C32 35.3432 30.6568 34 29 34H16C14.8954 34 14 33.1046 14 32C14 30.8954 14.8954 30 16 30H29C32.866 30 36 33.134 36 37C36 40.866 32.866 44 29 44C25.6112 44 22.7888 41.5938 22.14 38.3978C21.9202 37.3154 22.6196 36.2598 23.7022 36.04C24.7846 35.8202 25.8404 36.5196 26.06 37.6022Z"
        fill="white"
      />
    </svg>
  );
};

export default WindIcon;
